import ally from 'ally.js/ally';
import * as helpers from '../../js/helpers';

export default function flashInfoLocalstorage() {
    const flashInfo = document.querySelector('.flash-info');

    if (flashInfo === null) {
        return;
    }

    const flashInfoItems = flashInfo.querySelectorAll('.flash-info__item');
    const btnOpenClose = flashInfo.querySelector('.flash-info__button-close');
    let convertedString = '';
    for (let i = 0; i < flashInfoItems.length; i++) {
        const content = flashInfoItems[i].querySelector('.flash-info__content');
        if (content !== null) {
            convertedString += content.textContent.replace(/\n/g, ' ').replace(/\s/g, '');
        }
    }

    if (convertedString.length < 1) {
        return;
    }

    const btnClose = document.querySelector('.flash-info__button.-close');
    const hash = helpers.generateHash(convertedString);
    const flashInfoModal = document.querySelector('.flash-info__modal');

    if (localStorage.getItem('flash') === null || Number(localStorage.getItem('flash')) !== hash) {
        helpers.addClass(flashInfo, '-is-open');
        helpers.addClass(document.body, '-flash-info-open');
    }

    if (flashInfoModal) {
        const shouldHideOpt = document.getElementById('flash-info-no');
        const flashInfoModalSubmit = flashInfoModal.querySelector('.flash-info__modal-btn');

        flashInfoModalSubmit.addEventListener('click', () => {
            const flashInfoModalClose = document.querySelector('.fancybox-close-small');

            flashInfoModalClose.click();
            helpers.removeClass(flashInfo, '-is-open');
            helpers.removeClass(document.body, '-flash-info-open');

            if (shouldHideOpt && shouldHideOpt.checked) {
                localStorage.setItem('flash', hash);
            }
        });
    } else {
        btnClose.addEventListener('click', () => {
            flashInfo.classList.remove('-is-open');
            localStorage.setItem('flash', hash);
        });
    }

    const nextKeysHandler = (event) => {
        event.preventDefault();
        const nextElement = helpers.getNextFocusableElement(event.target, flashInfo);

        if (nextElement) {
            ally.element.focus(nextElement);
        }
    };

    const prevKeysHandler = (event) => {
        event.preventDefault();
        const prevElement = helpers.getPrevFocusableElement(event.target, flashInfo);

        if (prevElement) {
            ally.element.focus(prevElement);
        }
    };

    const keyHandler = ally.when.key({
        context: flashInfo,
        tab: (e) => {
            nextKeysHandler(e);
        },
        'shift+tab': (e) => {
            prevKeysHandler(e);
        },
    });

    let openPopup = false;
    window.addEventListener('keydown', (e) => {
        if (e.code === 'Escape' && helpers.hasClass(flashInfo, '-is-open')) {
            if (!openPopup) {
                $.fancybox.open(document.querySelector('.flash-info__modal'));
                openPopup = true;
            } else {
                $.fancybox.close(document.querySelector('.flash-info__modal'));
                openPopup = false;

                if (btnOpenClose) {
                    btnOpenClose.focus();
                }
            }
        }
    });

    window.addEventListener('load', () => {
        if (btnOpenClose) {
            btnOpenClose.focus();
        }
    });
}
